import * as Validation from "../../../common/utils/Validation";
import {checkUpdateTimeActionTypes} from "../constants/UtilityMiddlewareConstants";
import {addEditBillingGroupActionTypes} from "../../../veritas/add-edit/constants/AddEditActionConstants";
import {apiActionsBillingGroups} from "../constants/ApiMiddlewareConstants";

/**
 * This is the Middleware to validate the object generated by the add/edit Billing Group modal.
 * @param store, action
 * @returns Makes the call to custom validation procedure and conditionally dispatches
 * the check-update action or the post action
 */

const validateBillingGroupFormMiddleware = (store) => (next) => (action) => {

    switch (action.type) {

        case addEditBillingGroupActionTypes.VALIDATE_BILLING_GROUP_FORM: {
            next(action);

            const { billingGroupObj, formSource, authToken } = action.payload;
            // explicitly typecasting into number.
            billingGroupObj.base_price = Number(billingGroupObj.base_price)

            const doesValidate = formSource === "DPServicesForm" ?
                                    Validation.validateBillingGroupServicesForm(billingGroupObj) :
                                    Validation.validateBillingGroupForm(billingGroupObj);

            if (doesValidate) {
                if (billingGroupObj.id) {
                    // put, check update time
                    const billingGroupID = billingGroupObj.id;
                    store.dispatch({
                        type: checkUpdateTimeActionTypes.BILLING_GROUP,
                        payload: {billingGroupID, billingGroupObj, authToken},
                    })
                } else {
                    // post
                    store.dispatch({
                        type: apiActionsBillingGroups.POST,
                        payload: {billingGroupObj, formSource, authToken},
                    })
                }
            }
            break;

        }

        default: next(action);
    }
}

export default validateBillingGroupFormMiddleware;
